import { GameplayTier } from '#src/__generated__/globalTypes.ts';

export const GAMEPLAY_TIER_ORDER = [
  GameplayTier.GOAT,
  GameplayTier.STAR,
  GameplayTier.IMPACT,
  GameplayTier.ROSTER,
  GameplayTier.DNP,
];

export const isGameplayTier = (value: string): value is GameplayTier => {
  return GAMEPLAY_TIER_ORDER.includes(value as GameplayTier);
};

const sortByGameplayTier = (a: string, b: string) => {
  if (!isGameplayTier(a)) {
    return 1;
  }
  if (!isGameplayTier(b)) {
    return -1;
  }
  return GAMEPLAY_TIER_ORDER.indexOf(a) - GAMEPLAY_TIER_ORDER.indexOf(b);
};

export { sortByGameplayTier };

export const GAMEPLAY_TIER_LABELS = {
  [GameplayTier.GOAT]: 'Icon',
  [GameplayTier.STAR]: 'Star',
  [GameplayTier.IMPACT]: 'Key',
  [GameplayTier.ROSTER]: 'Roster',
  [GameplayTier.DNP]: 'Reserve',
};

// droprank can only be 0 | 2 | 3 | 4 | 5 | 6
export const dropRankToGameplayTier = (dropRank: number): GameplayTier => {
  return [
    GameplayTier.GOAT,
    undefined,
    GameplayTier.STAR,
    GameplayTier.IMPACT,
    GameplayTier.ROSTER,
    GameplayTier.DNP,
  ][dropRank]!;
};
